export * from './home.component';
export * from './features.component';
export * from './login.component';
export * from './forgotpassword.component';
export * from './forgotpasswordsubmit.component';
export * from './activate.component';
export * from './static.component';
export * from './conditions-page.component';



// WEBPACK FOOTER //
// ./src/app/pages/index.ts